// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/no-unknown-property */
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { jsx } from 'theme-ui'
import { Box } from '../../components/elements'

export const GradiantBox = ({ pathbg, pathcolor, ...props }) => {
  return (
    <svg
      width="100%"
      preserveAspectRatio="none"
      sx={{
        maxHeight: [360],

        '.cutout': { fill: 'bg' },
      }}
      viewBox="0 0 100 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="100" height="64" fill="url(#paint0_linear)" />

      <defs>
        <linearGradient
          id="paint0_linear"
          x1="45"
          y1="1.28"
          x2="40.9128"
          y2="56.2019"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="0.362208" stopColor="#010205" stopOpacity="0.26" />
          <stop offset="0.987245" stopColor="#03050E" stopOpacity="0.41" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const ReviewMobile = () => (
  <Box
    sx={{
      position: 'absolute',
      bottom: -100,
      left: `calc(100% / 2 - 66px)`,
      width: '100%',
      display: ['block', 'block', 'none'],
    }}
  >
    <Box mx="auto">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink"
        width="132px"
        height="132px"
      >
        <path
          fillRule="evenodd"
          fill="rgb(192, 57, 43)"
          d="M65.500,-0.002 C101.675,-0.002 131.000,29.323 131.000,65.497 C131.000,101.672 101.675,130.998 65.500,130.998 C29.325,130.998 -0.000,101.672 -0.000,65.497 C-0.000,29.323 29.325,-0.002 65.500,-0.002 Z"
        />
        <path
          fillRule="evenodd"
          stroke="rgb(255, 255, 255)"
          strokeWidth="2px"
          strokeDasharray="8, 4"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          fill="none"
          d="M65.500,4.134 C99.390,4.134 126.863,31.608 126.863,65.497 C126.863,99.388 99.390,126.861 65.500,126.861 C31.610,126.861 4.137,99.388 4.137,65.497 C4.137,31.608 31.610,4.134 65.500,4.134 Z"
        />
        <text
          kerning="auto"
          fontFamily="Myriad Pro"
          fill="rgb(0, 0, 0)"
          transform="matrix( 0.68947368421053, 0, 0, 0.68947368421053,27.5928684210526, 88.6368421052632)"
          fontSize="17.405px"
        >
          <tspan fontSize="17.405px" fontFamily="Barlow Condensed" fill="#FFFFFF">
            Certified&#32;Reviews
          </tspan>
        </text>
        <text
          kerning="auto"
          fontFamily="Myriad Pro"
          fill="rgb(0, 0, 0)"
          transform="matrix( 0.68947368421053, 0, 0, 0.68947368421053,52.7556868421053, 73.2210526315789)"
          fontSize="47.863px"
        >
          {' '}
          <tspan>
            <tspan fontSize="47.863px" fontFamily="Barlow Condensed" fill="#FFFFFF">
              &#57;&#48;
            </tspan>{' '}
          </tspan>
          <tspan x="0" dy="1.2em">
            {' '}
          </tspan>
        </text>
        <text
          kerning="auto"
          fontFamily="Myriad Pro"
          fill="rgb(0, 0, 0)"
          transform="matrix( 0.68947368421053, 0, 0, 0.68947368421053,90.6242868421052, 100.602631578947)"
          fontSize="14.504px"
        >
          <tspan fontSize="14.504px" fontFamily="Calibre" fill="#FFFFFF">
            &#53;
          </tspan>
        </text>
        <image
          x="39px"
          y="94px"
          width="46px"
          height="7px"
          href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAHCAMAAABAxI/7AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABcVBMVEX6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf6yRf///+46aBOAAAAeXRSTlMAQnkGiCgChjNGdQglBKbuJEH9gwE3/I4FrOsffkuQqPXHlmOX1uyhiRd3z++ki0k+qvfFlWAHmdjqn4c7zPlefa8WCni8Lyv2WQOBI9K4D3bCFCb4XLQOEM1Ia/tfuhPRQ3D6pzZywXqasBuPtUR8yDltTcOeisAZsE8ANQAAAAFiS0dEejjVhWoAAAAHdElNRQfjCw4UMTbZwxwpAAAA+klEQVQY0y3P51vCMBAG8FOhVRTBiJWqIKI4wK24K4KKW8G9te691/vfm0ubD7nf817yJEdEVFJKzirzeF1permrCp+LSk+Vqv7qQNBJakRtyFGdUa8phM2GRvee0ST3SLQ5hpZ4K4V9bQm0d3R6qSsZT6G7p7eP+qMDgxgaTtNIcnQM4xOTNGVBrukMaTMMZHM0O6c0n6eFFGNxiZZXVGQSra7J02l+jqP1DVZBAMVNia0EsL3DkS6bu3tE+wcQOOTkCMcw1edPYODUL3F2DiFsji5wiStZr62byO0dj3z/YOvFR6nQ0/PL6xvP/259fH4VuPlt2j+/f//FUzhkqEhuIQAAAABJRU5ErkJggg=="
        />
        <path
          fillRule="evenodd"
          stroke="rgb(255, 255, 255)"
          strokeWidth="2px"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          fill="rgb(44, 44, 44)"
          d="M65.500,17.924 C72.735,17.924 78.600,23.789 78.600,31.023 C78.600,38.259 72.735,44.125 65.500,44.125 C58.265,44.125 52.400,38.259 52.400,31.023 C52.400,23.789 58.265,17.924 65.500,17.924 Z"
        />
        <image
          x="51px"
          y="17px"
          width="29px"
          height="29px"
          href="data:img/png;base64,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"
        />
      </svg>
    </Box>
  </Box>
)
